import React from "react";
import styled from "styled-components";
import LeadInstallSection from "../LeadInstallSection";
import CreationLabSection from "../CreationLabSection";

/**
 * One desktop composition: shared shell, two columns, single border.
 * Mobile stacks the existing section treatments.
 */
const OfferLabBand = () => {
  return (
    <Band>
      <Shell>
        <Column>
          <LeadInstallSection embedded />
        </Column>
        <Divider aria-hidden="true" />
        <Column $lab>
          <CreationLabSection embedded />
        </Column>
      </Shell>
    </Band>
  );
};

export default OfferLabBand;

const Band = styled.div`
  border-top: 1px solid #45fe47;

  @media (max-width: 768px) {
    border-top: none;
  }
`;

const Shell = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: minmax(0, 1.2fr) 1px minmax(0, 0.9fr);
  align-items: stretch;
  background: linear-gradient(
    135deg,
    rgba(15, 15, 15, 0.9),
    rgba(30, 30, 30, 0.8)
  );
  backdrop-filter: blur(10px);
  border-left: 1px solid #45fe47;
  border-right: 1px solid #45fe47;
  border-bottom: 1px solid #45fe47;
  border-radius: 0 0 12px 12px;
  overflow: hidden;

  @media (max-width: 1200px) {
    margin: 0 25px;
  }

  @media (max-width: 768px) {
    display: block;
    margin: 0;
    background: none;
    backdrop-filter: none;
    border: none;
    border-radius: 0;
    overflow: visible;
  }
`;

const Divider = styled.div`
  background: rgba(69, 254, 71, 0.35);
  width: 1px;

  @media (max-width: 768px) {
    display: none;
  }
`;

const Column = styled.div`
  min-width: 0;
  display: flex;
  flex-direction: column;

  @media (min-width: 769px) {
    & > section,
    & > section > div {
      flex: 1;
      display: flex;
      flex-direction: column;
      min-height: 0;
    }

    ${({ $lab }) =>
      $lab &&
      `
      & > section > div {
        justify-content: center;
      }

      & > section > div > div,
      & > section > div > div > div {
        flex: 0 1 auto;
        display: block;
      }
    `}
  }

  @media (max-width: 768px) {
    display: block;
  }
`;
